import { render, staticRenderFns } from "./TechDataBreadcrumbsComponent.vue?vue&type=template&id=0f1dd9ca&"
import script from "./TechDataBreadcrumbsComponent.vue?vue&type=script&lang=js&"
export * from "./TechDataBreadcrumbsComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports